import { render, staticRenderFns } from "./HolidayAssignmentEdit.vue?vue&type=template&id=086ad162"
import script from "./HolidayAssignmentEdit.vue?vue&type=script&lang=js"
export * from "./HolidayAssignmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports